import React, { useState } from 'react'
import { Box } from '@mui/material'
import { EmtAvatar, EmtIcon, EmtSeparator, EmtTypography } from 'emt-components-v2'
import { useTranslation } from 'next-i18next'
import ProfileMenuPets from './ProfileMenuPets'
import { ConnectedUser } from '@/dataV3/User/ConnectedUser'

type PetsDropdownProps = {
  profile?: ConnectedUser
  variant?: 'seePets' | 'editPets'
  onPetClick?: () => void
}

const PetsDropdown = ({ profile, variant = 'editPets', onPetClick }: PetsDropdownProps) => {
  const { t } = useTranslation('common')
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        border: '1px solid #E5E5E5',
        padding: '14px',
        borderRadius: '16px',
        backgroundColor: '#fff',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          cursor: 'pointer',
          width: '100%',
        }}
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              marginRight: '5px',
              marginBottom: '-2.5px',
            }}
          >
            <EmtAvatar
              id="profil-avatar"
              variant="rounded"
              src={profile?.animals?.[0]?.mainPictureThumbnailUrl}
              sx={{ border: '2px solid white' }}
            />
            <EmtAvatar
              id="profil-avatar"
              variant="rounded"
              src={profile?.animals?.[1]?.mainPictureThumbnailUrl}
              sx={{
                position: 'absolute',
                top: '0',
                left: '0',
                transform: 'translate(5px, -5px)',
                zIndex: -1,
              }}
            />
          </Box>
          {variant === 'seePets' ? (
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <EmtTypography variant="body2" sx={{ userSelect: 'none', color: '#A5A3A9', lineHeight: '1.2' }}>
                {t('navigation.seePets', { name: profile?.displayName })}
              </EmtTypography>
              <EmtTypography variant="body1" fontWeight="bold" sx={{ userSelect: 'none', lineHeight: '1.2' }}>
                {profile?.animals?.map((pet) => pet.displayName).join(', ')}
              </EmtTypography>
            </Box>
          ) : (
            <EmtTypography variant="body1" fontWeight="bold" sx={{ userSelect: 'none' }}>
              {t('navigation.myPets')}
            </EmtTypography>
          )}
        </Box>
        <EmtIcon className="emt-down-1" sx={{ fontWeight: 'bold' }} />
      </Box>

      {isDropdownOpen && (
        <>
          <EmtSeparator />
          <ProfileMenuPets variant={variant} pets={profile?.animals} onClick={onPetClick} />
        </>
      )}
    </Box>
  )
}

export default PetsDropdown
